/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Report_Citation_PlaceholderInputs */

const en_dialog_report_citation_placeholder = /** @type {(inputs: Dialog_Report_Citation_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell us what happened with this citation`)
};

const es_dialog_report_citation_placeholder = /** @type {(inputs: Dialog_Report_Citation_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuéntanos qué pasó con esta cita`)
};

/**
* | output |
* | --- |
* | "Tell us what happened with this citation" |
*
* @param {Dialog_Report_Citation_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_report_citation_placeholder = /** @type {((inputs?: Dialog_Report_Citation_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Report_Citation_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_report_citation_placeholder(inputs)
	return en_dialog_report_citation_placeholder(inputs)
});